export default {
  methods: {
    $_stripString(value, strings) {
      if (Array.isArray(strings)) {
        strings.forEach(x => {
          value = value.replaceAll(x, "");
        });
      } else {
        value.replaceAll(strings, "");
      }
      return value;
    },
    $_toLocaleString(value, decimalPoint = 2, currency = null) {
      try {
        if (typeof value == "string") {
          value = Number(value);
        }
        if (typeof value == "number") {
          let options = {
            minimumFractionDigits: decimalPoint,
            maximumFractionDigits: decimalPoint
          };
          if (currency) {
            options.style = 'currency';
            options.currency = currency;
          }
          return value.toLocaleString("en-AU", options);
        }
      } catch (error) {
        console.warn(error);
      }
    },
    $_roundAccurately(number, decimalPlaces = 2) {
      return Number(
        Math.round(Number(number) + "e" + Number(decimalPlaces)) + "e-" + Number(decimalPlaces)
      );
    },
    $_roundDownAccurately(number, decimalPlaces = 2) {
      return Number(
        Math.floor(number + "e" + decimalPlaces) + "e-" + decimalPlaces
      );
    },
    calculateExcludingGst(value) {
      return (value / (100 + this.gst)) * 100;
    },
    calculateIncludingGst(value) {
      return (value / 100) * (100 + this.gst);
    },
    expiredDates(value) {
      if (moment(value).diff(moment(), 'days') < 0)
        return 'bg-red p-1 rounded text-white';
      else if (moment(value).diff(moment().add(1, 'months'), 'days') < 0)
        return 'bg-warning p-1 rounded text-white';
      else
        return '';
    },
    toTitleCase: function(value) {
      return value.replace(/_/g, ' ').replace(/\b[a-z]/g, (x) => x.toUpperCase());
    }
  }
};
